module.exports = __webpack_public_path__ + "static/media/SEM.3ad49ac6.svg";